"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.AnnualHomeExtraCoversSummaryWidget = void 0;
var React = require("react");
var plugin_journey_1 = require("@athena-portal/plugin-journey");
var FalconAccordionPlugin_1 = require("../../../components/FalconAccordionPlugin");
var commonFunctions_1 = require("../../../commonFunctions");
var services_1 = require("@falcon/services");
var Detail = function (_a) {
    var children = _a.children;
    return React.createElement("div", { className: "detail" }, children);
};
var DetailKey = function (_a) {
    var children = _a.children;
    return React.createElement("div", { className: "detail-key" }, children);
};
var DetailValue = function (_a) {
    var children = _a.children;
    return React.createElement("div", { className: "detail-value" }, children);
};
var AnnualHomeExtraCoversSummaryWidget = /** @class */ (function (_super) {
    __extends(AnnualHomeExtraCoversSummaryWidget, _super);
    function AnnualHomeExtraCoversSummaryWidget(props) {
        var _this = _super.call(this, props) || this;
        _this.navigateToQuotePage = function () {
            _this.props.engine.navigate("quote", false);
        };
        return _this;
    }
    AnnualHomeExtraCoversSummaryWidget.prototype.render = function () {
        return (React.createElement("div", { className: "collapsible-question-panel quote-details-widget" },
            React.createElement(FalconAccordionPlugin_1.FalconAccordion, { togglePositionTop: true, isShownClassName: "shown", toggleShown: React.createElement("div", { className: "toggle d-flex justify-content-between align-items-center" },
                    React.createElement("span", null),
                    React.createElement("span", { className: "font-weight-bold text-center fs-18" }, "Extra covers"),
                    React.createElement("span", { className: "toggle-icon collapse-icon" })), toggleHidden: React.createElement("div", { className: "toggle d-flex justify-content-between align-items-center" },
                    React.createElement("span", null),
                    React.createElement("span", { className: "font-weight-bold text-center fs-18" }, "Extra covers"),
                    React.createElement("span", { className: "toggle-icon expand-icon" })) }, this.renderExtraCoversDetails())));
    };
    AnnualHomeExtraCoversSummaryWidget.prototype.renderExtraCoversDetails = function () {
        return (React.createElement("div", { className: "accordion-content grid-make-2-col" },
            React.createElement("img", { className: "home-extra-covers-image mb-2", src: "/".concat(services_1.resourcesHelper.THEME, "/img/home-extra-covers.png"), alt: "Extra covers icon" }),
            React.createElement("div", { className: "section border-0 p-0" },
                React.createElement("div", { className: "section-contents mb-5" },
                    React.createElement(Detail, null,
                        React.createElement(DetailKey, null, "Personal Belongings:"),
                        React.createElement(DetailValue, null, this.props.interaction.annualHomeExtraCovers.personalPossessionCoverLimit ? "Up to " + (0, commonFunctions_1.getAmountToDisplay)(this.props.interaction.annualHomeExtraCovers.personalPossessionCoverLimit) : "No cover")),
                    React.createElement(Detail, null,
                        React.createElement(DetailKey, null, "Buildings Accidental Damage:"),
                        React.createElement(DetailValue, null, this.getCoverStatus(this.props.interaction.annualHomeFixedAddons.buildingAccidentalDamage))),
                    React.createElement(Detail, null,
                        React.createElement(DetailKey, null, "Contents Accidental Damage:"),
                        React.createElement(DetailValue, null, this.getCoverStatus(this.props.interaction.annualHomeFixedAddons.contentsAccidentalDamage))),
                    React.createElement(Detail, null,
                        React.createElement(DetailKey, null, "Home Legal Expenses:"),
                        React.createElement(DetailValue, null, this.getCoverStatus(this.props.interaction.annualHomeFixedAddons.homeLegalExpenses))),
                    React.createElement(Detail, null,
                        React.createElement(DetailKey, null, "Home Emergency:"),
                        React.createElement(DetailValue, null, this.getCoverStatus(this.props.interaction.annualHomeFixedAddons.homeEmergency))))),
            React.createElement("button", { type: "button", className: "btn btn-primary btn-add btn-summary-chapter grid-col-2", onClick: this.navigateToQuotePage }, "Edit extra covers")));
    };
    AnnualHomeExtraCoversSummaryWidget.prototype.getCoverStatus = function (cover) {
        if (this.props.interaction.coverTier === services_1.HomeCoverTier.GOLD) {
            return "Included";
        }
        if (cover) {
            return "Added";
        }
        else {
            return "Not included";
        }
    };
    return AnnualHomeExtraCoversSummaryWidget;
}(plugin_journey_1.WidgetBase));
exports.AnnualHomeExtraCoversSummaryWidget = AnnualHomeExtraCoversSummaryWidget;
//# sourceMappingURL=AnnualHomeExtraCoversSummaryWidget.js.map


//////////////////
// WEBPACK FOOTER
// ../falcon-plugins/plugin-falcon-journey/dist/widgets/annual/home/AnnualHomeExtraCoversSummaryWidget.js
// module id = 3699
// module chunks = 0